import { Controller } from "@hotwired/stimulus"
import { PACT_FORM_DATA_KEY } from "../constants"

export default class extends Controller {
  static targets = ["form", "sellerId", "buyerId", "currency"]
  static values = {
    // Avoid hard-coded IDs in JS; component may provide defaults via data-values.
    defaultSellerId: { type: String, default: "" },
    defaultBuyerId: { type: String, default: "" }
  }

  connect() {
    this.initializeFromLocalStorage()
    this.setupFormHandlers()
  }

  initializeFromLocalStorage() {
    const storedData = localStorage.getItem(PACT_FORM_DATA_KEY)

    if (storedData) {
      const data = JSON.parse(storedData)
      this.sellerIdTarget.value = data.seller_id || this.defaultSellerIdValue
      this.buyerIdTarget.value = data.buyer_id || this.defaultBuyerIdValue
    } else {
      this.sellerIdTarget.value = this.defaultSellerIdValue
      this.buyerIdTarget.value = this.defaultBuyerIdValue
    }
  }

  setupFormHandlers() {
    this.formTarget.addEventListener('submit', (e) => {
      if (!this.formTarget.checkValidity()) {
        e.preventDefault()
        this.formTarget.reportValidity()
        return
      }
      localStorage.removeItem(PACT_FORM_DATA_KEY)
    })
  }

  handleSubmit() {
  }
}
